<template>
  <el-dialog :title="title" :visible.sync="xzVisible" :close-on-click-modal="false" width="79%" center :before-close="closeadd">
    <div class="topForm">
      <el-form :model="FormData" ref="FormData" class="demo-dynamic" :rules="Rules" :inline="true">
        <el-form-item prop="primaryCustomerTaxId" label="一级货主:">
          <el-select v-model="FormData.primaryCustomerTaxId" size="mini" placeholder="请选择货主" filterable clearable>
            <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName" :value="item.taxpayerNumber"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="customerTaxId" label="二级货主:">
          <el-select v-model="FormData.customerTaxId" size="mini" placeholder="请选择货主" filterable clearable>
            <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName" :value="item.taxpayerNumber"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="forecastDate" label="日期:">
          <el-date-picker v-model="FormData.forecastDate " size="mini" placeholder="选择日期" type="date" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item prop="arrivalMethod" label="到货方式:">
          <el-select v-model="FormData.arrivalMethod" clearable placeholder="请选择" :disabled='arrivalMethodDis' filterable size="mini">
            <el-option v-for="(item, index) in arrivalMethodData" :key="index" :label="item.label" :value="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="plateNumber" label="车船号:">
          <el-input v-model="FormData.plateNumber" placeholder="请输入车船号" size="mini"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <!-- 新增 -->
    <div class="bottomTable" v-if="title=='新增预报'">
      <div class="detailsTitle">
        <h4>货物信息</h4>
      </div>
      <div ref="searchBox2" style="margin-top: 5px;margin-bottom:5px;margin-left:10px;">
        <span>
          总吨数:
          <span style="color: red">{{Number(totalAllWeight).toFixed(4)}}</span> &nbsp;吨
        </span>
        <span style="margin-left: 15px">
          总件数:
          <span style="color: red">{{ totalNumber }}</span> &nbsp;件
        </span>
      </div>
      <el-table min-height="300px" max-height="350px" size="mini" border center bordersize="mini" ref="tableref" :data="table" :header-cell-class-name="Add" style="width: 100%" class="elTab">
        <el-table-column prop="productType" label="货物类型" align="center">
          <template slot-scope="scope1">
            <el-select filterable clearable v-model="scope1.row.productType" size="mini" placeholder="请选择货物类型" @change="selectProductType(scope1.row)">
              <el-option v-for="(item,index) in huowuOptions" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="steelMillName" label="产地" align="center">
          <template slot-scope="scope1">
            <el-select filterable clearable v-model="scope1.row.steelMillName" size="mini" placeholder="请选择产地" :disabled="scope1.row.disChandi" @change="selectChandi(scope1.row)">
              <el-option v-for="(item,index) in scope1.row.chanDiOptions" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="specification" label="规格" align="center">
          <template slot-scope="scope1">
            <el-select filterable clearable v-model="scope1.row.specification" size="mini" placeholder="请选择规格" :disabled="scope1.row.disGuige" @change="selectGuige(scope1.row)">
              <el-option v-for="(item,index) in scope1.row.guigeOptions" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="model" label="材质" align="center">
          <template slot-scope="scope1">
            <el-select filterable clearable v-model="scope1.row.model" size="mini" placeholder="请选择材质" :disabled="scope1.row.disCaizhi" @change="selectCaizhi(scope1.row)">
              <el-option v-for="(item,index) in scope1.row.caizhiOptions" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="warehouseId" label="仓位" align="center">
          <template slot-scope="scope1">
            <el-select ref="selectProvinces" @visible-change='isShowSelectOptions' filterable clearable v-model="scope1.row.warehouseId" size="mini" placeholder="请选择仓位" @change="selectCangwei(scope1.row)">
              <el-option v-for="(item,index) in warehouseOptions" :key="index" :label="item.warehouseName" :value="item.warehouseId"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="planNumber" label="计划件数" align="center">
          <template slot-scope="scope1">
            <el-input v-model.trim="scope1.row.planNumber" v-number-input.float="0" maxlength="50" placeholder="请输入件数" size="mini" :disabled="scope1.row.disJianshu" @input="NumberInput(scope1.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="planWeight" label="计划重量" align="center">
          <template slot-scope="scope1">
            <el-input v-model.trim="scope1.row.planWeight" v-number-input.float="4" maxlength="50" placeholder="请输入重量" size="mini" :disabled="scope1.row.disLizhong" @blur="weightInput(scope1.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" align="center">
          <template slot-scope="scope1">
            <el-button @click="delClick(scope1.$index, scope1.row)" type="text" size="small" :disabled="scope1.$index =='0'">删除</el-button>
            <el-button @click="addtable(scope1.$index, scope1.row)" type="text" size="small" :disabled='scope1.row.addShow'>新增</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 修改 -->
    <div class="bottomTable" v-if="title=='修改预报'">
      <div class="detailsTitle">
        <h4>货物信息</h4>
      </div>
      <div ref="searchBox2" style="margin-top: 5px;margin-bottom:5px;margin-left:10px;">
        <span>
          总吨数:
          <span style="color: red">{{Number(allPlanWeight).toFixed(4)}}</span> &nbsp;吨
        </span>
        <span style="margin-left: 15px">
          总件数:
          <span style="color: red">{{ allPlanNumber }}</span> &nbsp;件
        </span>
      </div>
      <el-table min-height="300px" max-height="350px" size="mini" border center bordersize="mini" ref="tableref" :data="changeTable" :header-cell-class-name="Add" style="width: 100%" class="elTab">
        <el-table-column prop="productType" label="货物类型" align="center">
          <template slot-scope="scope1">
            <el-select filterable clearable disabled v-model="scope1.row.productType" size="mini" placeholder="请选择货物类型" @change="selectProductType(scope1.row)">
              <el-option v-for="(item,index) in huowuOptions" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="steelMillName" label="产地" align="center">
          <template slot-scope="scope1">
            <el-select filterable clearable v-model="scope1.row.steelMillName" size="mini" placeholder="请选择产地" disabled @change="selectChandi(scope1.row)">
              <el-option v-for="(item,index) in scope1.row.chanDiOptions" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="specification" label="规格" align="center">
          <template slot-scope="scope1">
            <el-select filterable clearable v-model="scope1.row.specification" size="mini" placeholder="请选择规格" disabled @change="selectGuige(scope1.row)">
              <el-option v-for="(item,index) in scope1.row.guigeOptions" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="model" label="材质" align="center">
          <template slot-scope="scope1">
            <el-select filterable clearable v-model="scope1.row.model" size="mini" placeholder="请选择材质" disabled @change="selectCaizhi(scope1.row)">
              <el-option v-for="(item,index) in scope1.row.caizhiOptions" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="warehouseId" label="仓位" align="center">
          <template slot-scope="scope1">
            <el-select ref="selectProvinces" @visible-change='isShowSelectOptions' filterable clearable v-model="scope1.row.warehouseId" size="mini" placeholder="请选择仓位" @change="selectCangwei1(scope1.row)">
              <el-option v-for="(item,index) in warehouseOptions" :key="index" :label="item.warehouseName" :value="item.warehouseId"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="planNumber" label="计划件数" align="center">
          <template slot-scope="scope1">
            <el-input v-model.trim="scope1.row.planNumber" v-number-input.float="0" maxlength="50" placeholder="请输入件数" size="mini" disabled @input="NumberInput(scope1.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="planWeight" label="计划重量" align="center">
          <template slot-scope="scope1">
            <el-input v-model.trim="scope1.row.planWeight" v-number-input.float="4" maxlength="50" placeholder="请输入重量" size="mini" disabled @blur="weightInput(scope1.row)"></el-input>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" style=" margin: 15px auto">
      <el-button @click="closeadd">取 消</el-button>
      <el-button type="primary" :loading="Loading" @click="addDialog">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  getVirtualBalingList,
  getWeighingMethodList
} from '@/api/wms-stock'
import {
  getMasterDetailById, // 修改数据回显
  getSummaryList,
  getSummaryPlanWeightAndPiece,
  updateMaster, // 修改
  zidianKuwei,
  addMasterAndSummary // 新增
} from '@/api/wms-access'
import DonMessage from '@/utils/message'
export default {
  name: 'rukuPlanDialog',
  data () {
    return {
      FormData: {
        plateNumber: '',
        primaryCustomerTaxId: '',
        primaryCustomerName: '',
        customerTaxId: '',
        customerName: '',
        arrivalMethod: '船运',
        forecastDate: ''
      },
      Rules: {
        plateNumber: [{
          required: true,
          message: '请输入车船号',
          trigger: 'blur'
        }],
        forecastDate: [{
          required: true,
          message: '请选择日期',
          trigger: 'change'
        }],
        primaryCustomerTaxId: [{
          required: true,
          message: '请选择一级货主',
          trigger: 'change'
        }],
        customerTaxId: [{
          required: true,
          message: '请选择二级货主',
          trigger: 'change'
        }],
        arrivalMethod: [{
          required: true,
          message: '请选择到货方式',
          trigger: 'blur'
        }]
      },
      table: [],
      changeTable: [],
      Loading: false,
      chanDiOptions: [],
      huowuOptions: [],
      guigeOptions: [],
      caizhiOptions: [],
      arrivalMethodData: [
        // {
        //   value: '1',
        //   label: '火运'
        // },
        {
          value: '2',
          label: '汽运'
        },
        {
          value: '3',
          label: '船运'
        }
      ],
      warehouseOptions: [],
      allPlanNumber: 0,
      allPlanWeight: 0,
      totalAllWeight: 0,
      totalNumber: 0,
      arrivalMethodDis: false
    }
  },
  props: {
    title: {
      type: String,
      default: '新增预报'
    },
    xzVisible: {
      type: Boolean,
      default: false
    },
    xztableData: {
      type: Array
    },
    RKData: {
      type: Array
    },
    shipForecastMasterId: {
      type: String
    }
  },
  watch: {
    xztableData: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val.length == 0) {
          this.table = []
          let obj = {
            steelMillName: '',
            productType: '',
            specification: '',
            model: '',
            planNumber: '',
            planWeight: '',
            warehouseId: '',
            warehouseName: '',
            singletonWeight: '',
            disChandi: true,
            disGuige: true,
            disCaizhi: true,
            disJianshu: true,
            disLizhong: true,
            disGbjz: true,
            chanDiOptions: [],
            huowuOptions: [],
            guigeOptions: [],
            caizhiOptions: [],
            addShow: false,
            inWeighingMethod: ''
          }
          this.table.push(obj)
        } else {
          let hwInfos = JSON.parse(window.localStorage.getItem('HwInfos'))
          val.map(item => {
            item.disLizhong = true
          })
          this.table = JSON.parse(JSON.stringify(val))
          this.table.map(item => this.getOptions(item, hwInfos))
        }
      }
    }
  },
  methods: {
    // 小星星
    Add (obj) {
      if (obj.column.property == 'productType' || obj.column.property == 'steelMillName' ||
        obj.column.property == 'specification' || obj.column.property == 'model' ||
        obj.column.property == 'planNumber' || obj.column.property == 'planWeight' ||
        obj.column.property == 'warehouseId') {
        return 'star'
      }
    },
    // 是否显示下拉框
    isShowSelectOptions (isShowSelectOptions) {
      if (!isShowSelectOptions) this.$refs.selectProvinces.blur()
    },
    getOptions (row, hwInfos) {
      this.$set(row, 'chanDiOptions', Array.from(new Set(hwInfos.filter(item => item.productType == row.productType)
        .map(item => item.placeOfOrigin))))
      this.$set(row, 'guigeOptions', Array.from(new Set(hwInfos.filter(item => item.productType == row.productType &&
        item.placeOfOrigin == row.steelMillName).map(item => item.specification))))
      this.$set(row, 'caizhiOptions', Array.from(new Set(hwInfos.filter(item => item.productType == row.productType &&
        item.placeOfOrigin == row.steelMillName && item.specification == row.specification).map(item => item
          .model))))
    },
    closeadd () {
      this.$emit('update:xzVisible', false)
      this.$parent.xztableData = []
      this.$parent.shipForecastMasterId = ''
    },
    // 判断数组的每一项是否相等
    isAllEqual (array) {
      console.log(array)
      const arr1 = Array.from(new Set(array))
      if (arr1.length == array.length) return false
      else return true
      // if (array.length > 0) {
      //   return !array.some(function (value, index) {
      //     return value !== array[0]
      //   })
      // } else {
      //   return true
      // }
    },
    addDialog () {
      this.$refs.FormData.validate(valid => {
        if (valid) {
          this.FormData.primaryCustomerName = this.RKData.filter(item => item.taxpayerNumber == this.FormData
            .primaryCustomerTaxId)[0].custerName
          this.FormData.customerName = this.RKData.filter(item => item.taxpayerNumber == this.FormData
            .customerTaxId)[0].custerName
          if (this.title == '修改预报') {
            this.updateMaster()
          } else {
            let specificationArr = []
            for (let i = 0; i < this.table.length; i++) {
              if (this.table[i].productType == '') {
                this.$message({
                  message: '请选择货物类型',
                  type: 'error'
                })
                return
              }
              if (this.table[i].steelMillName == '') {
                this.$message({
                  message: '请选择产地',
                  type: 'error'
                })
                return
              }
              if (this.table[i].specification == '') {
                this.$message({
                  message: '请选择规格',
                  type: 'error'
                })
                return
              }
              if (this.table[i].model == '') {
                this.$message({
                  message: '请选择材质',
                  type: 'error'
                })
                return
              }
              if (this.table[i].warehouseId == '') {
                this.$message({
                  message: '请选择仓位',
                  type: 'error'
                })
                return
              }
              if (this.table[i].inWeighingMethod != 1 && this.table[i].planWeight / 1 == 0) {
                this.$message({
                  message: '请填写计划重量',
                  type: 'error'
                })
                return
              }
              if (this.table[i].planNumber / 1 == 0) {
                this.$message({
                  message: '件数不能为空或0',
                  type: 'error'
                })
                return
              }
              specificationArr.push(this.table[i].productType + this.table[i].steelMillName + this.table[i].specification + this.table[i].model)
            }
            // 判断规格是否重复
            if (specificationArr.length > 1) {
              if (this.isAllEqual(specificationArr)) {
                this.$message.error('同货物类型|产地|规格|材质的货物不能重复！')
              } else {
                this.addMasterAndSummary()
              }
            } else {
              this.addMasterAndSummary()
            }
          }
        } else {

        }
      })
    },
    // 调接口
    addMasterAndSummary () {
      this.Loading = true
      let params = {
        primaryCustomerTaxId: this.FormData.primaryCustomerTaxId, // 一级客户名称,
        primaryCustomerName: this.FormData.primaryCustomerName, // 一级客户纳税识别码,
        customerName: this.FormData.customerName, // 二级货主,
        customerTaxId: this.FormData.customerTaxId, // 二级客户纳税识别码
        forecastDate: this.FormData.forecastDate, // 预报日期,
        arrivalMethod: this.FormData.arrivalMethod, // 到货方式,
        plateNumber: this.FormData.plateNumber, // 车船号,
        shipForecastSummaryList: this.table
      }
      addMasterAndSummary(params).then(res => {
        this.Loading = false
        DonMessage.success('添加成功')
        this.$emit('update:xzVisible', false)
        this.$parent.getDataList()
        this.$parent.xztableData = []
      }).catch(err => {
        this.Loading = false
        DonMessage.error(err.message)
      })
    },
    // 修改接口
    updateMaster () {
      this.Loading = true
      let params = {
        primaryCustomerTaxId: this.FormData.primaryCustomerTaxId, // 一级客户名称,
        primaryCustomerName: this.FormData.primaryCustomerName, // 一级客户纳税识别码,
        customerName: this.FormData.customerName, // 二级货主,
        customerTaxId: this.FormData.customerTaxId, // 二级客户纳税识别码
        forecastDate: this.FormData.forecastDate, // 预报日期,
        arrivalMethod: this.FormData.arrivalMethod, // 到货方式,
        plateNumber: this.FormData.plateNumber, // 车船号,
        shipForecastMasterId: this.shipForecastMasterId,
        shipForecastSummaryList: this.changeTable // 船运预报子表List
        // shipForecastSummaryId 船运预报子表id 必填
        //  warehouseId 仓库ID 必填
        //  warehouseName 仓库名称 必填
      }
      for (let i = 0; i < this.changeTable.length; i++) {
        if (this.changeTable[i].warehouseId == '') {
          this.Loading = false

          this.$message({
            message: '请选择仓位',
            type: 'error'
          })
          return
        }
      }
      updateMaster(params).then(res => {
        this.Loading = false
        DonMessage.success('修改成功')
        this.$parent.getDataList()
        this.$parent.xztableData = []
        this.$parent.shipForecastMasterId = ''
        this.$emit('update:xzVisible', false)
      }).catch(err => {
        this.Loading = false
        DonMessage.error(err.message)
      })
    },
    delClick (index, row) {
      this.table.splice(index, 1)
      this.table[this.table.length - 1].addShow = false
      this.totalNumber = this.table.reduce((pre, cur) => {
        return pre / 1 + cur.planNumber / 1
      }, 0)
      this.totalAllWeight = this.table.reduce((pre, cur) => {
        return pre / 1 + cur.planWeight / 1
      }, 0).toFixed(4)
    },
    addtable (index, row) {
      let tabLength = this.table.length - 1
      let obj = {
        steelMillName: this.table[tabLength].steelMillName,
        placeOfOrigin: this.table[tabLength].placeOfOrigin,
        productType: this.table[tabLength].productType,
        productTypeName: this.table[tabLength].productTypeName,
        specification: this.table[tabLength].specification,
        model: this.table[tabLength].model,
        planNumber: this.table[tabLength].planNumber,
        planWeight: this.table[tabLength].planWeight,
        singletonWeight: this.table[tabLength].singletonWeight,
        disChandi: false,
        disGuige: false,
        disCaizhi: false,
        disJianshu: false,
        disLizhong: false,
        disGbjz: false,
        chanDiOptions: [],
        huowuOptions: [],
        guigeOptions: [],
        caizhiOptions: [],
        warehouseId: this.table[tabLength].warehouseId,
        warehouseName: this.table[tabLength].warehouseName,
        addShow: false,
        inWeighingMethod: ''
      }
      getWeighingMethodList({
        productType: obj.productType
      }).then(res => {
        if (res.length > 0) {
          obj.inWeighingMethod = res[0].inWeighingMethod
          if (obj.inWeighingMethod != '1') {
            obj.disLizhong = false
          } else {
            obj.disLizhong = true
          }
          if (row.productType != '') {
            getVirtualBalingList({
              productType: obj.productType
            }).then(res => {
              obj.chanDiOptions = Array.from(new Set(res.map(item => item.placeOfOrigin)))
            }).catch(err => {
              this.$message({
                message: err.message,
                type: 'error'
              })
            })
          }
        } else {
          this.$message({
            message: '计重方式未配置，请联系管理员',
            type: 'error'
          })
        }
      }).catch(err => {
        this.$message({
          message: err.message,
          type: 'error'
        })
      })
      getVirtualBalingList({
        productType: obj.productType,
        productTypeName: obj.productTypeName,
        steelMillName: obj.steelMillName, // （产地  非必填）
        placeOfOrigin: obj.placeOfOrigin,
        model: '', // （材质 非必填）
        specification: '' // （规格  非必填）
      }).then(res => {
        obj.guigeOptions = Array.from(new Set(res.map(item => item.specification)))
      }).catch(err => {
        this.$message({
          message: err.message,
          type: 'error'
        })
      })
      getVirtualBalingList({
        productType: obj.productType,
        productTypeName: obj.productTypeName,
        steelMillName: obj.steelMillName, // （产地  非必填）
        placeOfOrigin: obj.placeOfOrigin,
        model: '', // （材质 非必填）
        specification: obj.specification // （规格  非必填）
      }).then(res => {
        obj.caizhiOptions = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message({
          message: err.message,
          type: 'error'
        })
      })
      this.table.push(obj)
      this.table[tabLength].addShow = true
      this.totalNumber = this.table.reduce((pre, cur) => {
        return pre / 1 + cur.planNumber / 1
      }, 0)
      this.totalAllWeight = this.table.reduce((pre, cur) => {
        return pre / 1 + cur.planWeight / 1
      }, 0).toFixed(4)
    },
    getVirtualBalingLists () {
      getVirtualBalingList(
        this.selectObj
      )
        .then(res => {
          window.localStorage.setItem('HwInfos', JSON.stringify(res))
          let productArr = []
          res.forEach(item => {
            let obj = {}
            obj.id = item.productType
            obj.name = item.productTypeName
            productArr.push(obj)
          })
          const ress = new Map()
          let arrNew = productArr.filter((arr) => !ress.has(arr.id) && ress.set(arr.id, 1))
          this.huowuOptions = arrNew
        })
        .catch(err => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    selectProductType (row) {
      row.disChandi = false
      row.disGuige = true
      row.disCaizhi = true
      row.disJianshu = true
      row.disLizhong = true
      row.disGbjz = true
      row.steelMillName = ''
      row.specification = ''
      row.model = ''
      row.planNumber = ''
      row.planWeight = ''
      row.singletonWeight = ''
      row.placeOfOrigin = ''
      row.chanDiOptions = []
      row.guigeOptions = []
      row.caizhiOptions = []
      row.productTypeName = this.huowuOptions.filter(item => item.id == row.productType)[0].name
      getWeighingMethodList({
        productType: row.productType
      })
        .then(res => {
          if (res.length > 0) {
            row.inWeighingMethod = res[0].inWeighingMethod
            if (row.inWeighingMethod != '1') {
              row.disLizhong = false
            } else {
              row.disLizhong = true
            }
            if (row.productType != '') {
              getVirtualBalingList({
                ...row
              })
                .then(res => {
                  row.chanDiOptions = Array.from(new Set(res.map(item => item.placeOfOrigin)))
                })
                .catch(err => {
                  this.$message({
                    message: err.message,
                    type: 'error'
                  })
                })
            }
          } else {
            this.$message({
              message: '计重方式未配置，请联系管理员',
              type: 'error'
            })
          }
        })
        .catch(err => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    selectChandi (row) {
      row.disGuige = false
      row.disCaizhi = true
      row.disJianshu = true
      row.disGbjz = true
      row.specification = ''
      row.model = ''
      row.planNumber = ''
      row.planWeight = ''
      row.singletonWeight = ''
      row.placeOfOrigin = ''

      row.guigeOptions = []
      row.caizhiOptions = []
      row.placeOfOrigin = row.steelMillName
      if (row.steelMillName != '') {
        getVirtualBalingList({
          ...row
        })
          .then(res => {
            row.guigeOptions = Array.from(new Set(res.map(item => item.specification)))
          })
          .catch(err => {
            this.$message({
              message: err.message,
              type: 'error'
            })
          })
      }
    },
    selectGuige (row) {
      row.disCaizhi = false
      row.disJianshu = true
      row.disGbjz = true
      row.model = ''
      row.planNumber = ''
      row.planWeight = ''
      row.singletonWeight = ''
      row.caizhiOptions = []
      row.placeOfOrigin = row.steelMillName

      if (row.specification != '') {
        getVirtualBalingList({
          ...row
        })
          .then(res => {
            row.caizhiOptions = Array.from(new Set(res.map(item => item.model)))
          })
          .catch(err => {
            this.$message({
              message: err.message,
              type: 'error'
            })
          })
      }
    },
    selectCaizhi (row) {
      row.disJianshu = false
      row.disGbjz = true
      row.planNumber = ''
      row.planWeight = ''
      row.placeOfOrigin = row.steelMillName
      row.singletonWeight = ''
      getVirtualBalingList({
        ...row
      })
        .then(res => {
          row.singletonWeight = res[0].weight
        })
        .catch(err => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    NumberInput (row) {
      row.disGbjz = false
      if (row.inWeighingMethod == '2') {
        row.planWeight = ''
        this.totalAllWeight = this.table.reduce((pre, cur) => {
          return pre / 1 + cur.planWeight / 1
        }, 0).toFixed(4)
      } else {
        row.planWeight = (row.planNumber / 1 * row.singletonWeight).toFixed(4)
        this.totalAllWeight = this.table.reduce((pre, cur) => {
          return pre / 1 + cur.planWeight / 1
        }, 0).toFixed(4)
      }
      this.totalNumber = this.table.reduce((pre, cur) => {
        return pre / 1 + cur.planNumber / 1
      }, 0)
    },
    weightInput (row) {
      this.totalAllWeight = this.table.reduce((pre, cur) => {
        return pre / 1 + cur.planWeight / 1
      }, 0).toFixed(4)
    },
    // 字典--库位
    zidianKuweiS () {
      zidianKuwei({})
        .then((res) => {
          this.warehouseOptions = res
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    selectCangwei (row) {
      if (row.warehouseId != '') {
        row.warehouseName = this.warehouseOptions.filter(item => item.warehouseId == row.warehouseId)[0].warehouseName
      }
    },
    // 获取库位下拉框其他值
    selectCangwei1: function (row) {
      let choosenKuwei = this.warehouseOptions.filter(
        (item) => item.warehouseId === row.warehouseId
      )[0]
      // this.kuweiIds = choosenKuwei.warehouseId
      row.warehouseName = choosenKuwei.warehouseName
    },
    // 年月日
    timeStamp (value) {
      if (!value) return ''
      var now = new Date(value)
      var year = now.getFullYear()
      var month = now.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var date = now.getDate()
      if (date < 10) {
        date = '0' + date
      }
      return year + '-' + month + '-' + date
    },
    getSummaryPlanWeightAndPieceS () {
      getSummaryPlanWeightAndPiece({
        shipForecastMasterId: this.shipForecastMasterId,
        pageNo: 1,
        pageSize: 20

      })
        .then(res => {
          this.allPlanNumber = res.allPlanNumber
          this.allPlanWeight = res.allPlanWeight
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 修改数据回显
    getMasterDetailById () {
      getMasterDetailById(this.shipForecastMasterId)
        .then(res => {
          this.FormData.plateNumber = res.plateNumber
          this.FormData.primaryCustomerTaxId = res.primaryCustomerTaxId
          this.FormData.customerTaxId = res.customerTaxId
          this.FormData.arrivalMethod = res.arrivalMethod
          this.FormData.plateNumber = res.plateNumber
          this.FormData.forecastDate = this.timeStamp(res.forecastDate)
        }).catch(err => {
          DonMessage.error(err.message)
        })
    }
  },
  created () {
    this.getVirtualBalingLists()
    this.zidianKuweiS()
    if (this.title == '修改预报') {
      this.getMasterDetailById()
      this.getSummaryPlanWeightAndPieceS()
      getSummaryList({
        shipForecastMasterId: this.shipForecastMasterId,
        pageNo: 1,
        pageSize: 20

      })
        .then(res => {
          this.changeTable = res.list
        })
        .catch(error => {
          DonMessage.error(error.message)
        })

      this.arrivalMethodDis = true
    } else {
      this.arrivalMethodDis = false
    }
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.addDialog()
      }
    }
  },
  mounted () { }

}

</script>

<style lang="less" scoped>
/deep/.el-table th.star div::before {
  content: '*' !important;
  color: red !important;
}
</style>
